import React from 'react';
import { Modal } from 'botbit-ui-components';
import translate from "../../../config/translations/translate";
import './MobileScreenUnavailableMessage.scss';
import { envConfig } from '../../../config/config.js';

const getV2DashboardUrl = () => {
	if (envConfig.v2LoginUrl) {
	  return envConfig.v2LoginUrl + '?returnUrl=' + encodeURIComponent('/dashboard');
	}
	return "/dashboard";
};

const MobileScreenUnavailableMessage = ({isOpen, t}) => {
    return (
 
 
            <Modal className="mobile-screen-unavailable-message-modal" isOpen={isOpen} toggle={() => {}} width="50%" height="90%">
                <div className="mobile-screen-unavailable-message-header">
                    <img className="mobile-screen-unavailable-message-header-logo" src="/static/img/RAY_transparent_logo.png" alt="Mobile Screen Unavailable" />
                </div>
                <div className="mobile-screen-unavailable-message-content">
                    <h2 className="mobile-screen-unavailable-message-content-title">
                    {t('title')}
                    <br />
                    {t('subtitle')}
                    <br />
                    {t('description')} <a href={getV2DashboardUrl()} style={{cursor: 'pointer', textDecoration: 'underline'}}>Dashboard</a>
                    </h2>
                </div>
            </Modal>

        
    )
}

MobileScreenUnavailableMessage.translations = {
    title: {
        es: "Esta pantalla no está disponible en versión móvil.",
        en: "This screen is not available in mobile version."
    },
    subtitle: {
        es: "Estamos mejorando nuestra plataforma, pronto estará disponible.",
        en: "We are improving our platform, soon it will be available."
    },
    description: {
        es: "Por ahora, puedes ver el ",
        en: "For now, you can see the "
    },
}


export default translate(MobileScreenUnavailableMessage);